<template>
  <div id="WorkSituation">
    <div v-if="workProcess.length > 0 || Object.keys(workProcess).length > 0">
      <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
        <van-notice-bar
          color="#1989fa"
          background="#ecf9ff"
          left-icon="info-o"
          mode="closeable"
        >当前岗位({{getAddr().OrganName}}-{{getAddr().RoleName}})可查看工作任务情况, 显示方式可以切换为任务线和时间轴视图.</van-notice-bar>
        <div class="text-left">
          <!-- 切换状态 -->
          <div class="side-nav" style="position: relative;">
            <h5 class="vant-title color-black">
              <!-- <img src="../assets/logo.png" class="mt-2 mr-2" width="26px" /> -->
              <span>工作情况{{(listMode)? '时间轴':'分类视图'}}</span>
            </h5>
            <div class="mobile-switch-lang">
              <i
                class="fa fa-lg fa-th-large"
                :class="!listMode?'active':''"
                @click="listMode=false"
              ></i>
              <i class="fa fa-lg fa-navicon" :class="listMode?'active':''" @click="listMode=true"></i>
            </div>
          </div>
          <template class v-if="listMode">
            <!-- 时间轴列表模式显示工作任务 -->
            <div class="ml-2 mr-2">
              <template v-for="(item,index) in workProcess">
                <template>
                  <van-tag
                    v-if="(index==0)"
                    :key="index"
                    class="mb-2 ls-1"
                    mark
                  >{{formatShortDate(item.BeginTime)}}</van-tag>
                  <van-tag
                    v-else-if="(formatShortDate(item.BeginTime) != formatShortDate(workProcess[index-1].BeginTime))"
                    :key="index"
                    class="mb-2 ls-1"
                    mark
                  >{{formatShortDate(item.BeginTime)}}</van-tag>
                  <van-cell is-link class="mb-2 border-radius" :key="index" @click="processItemBtn(item)">
                    <template slot="icon">
                      <van-circle
                        v-model="item.ratio"
                        :rate="item.ratio"
                        :speed="100"
                        :color="gradientColor(item.ProcessLevel,item.ratio)"
                        :stroke-width="30"
                        :text="textAbbreviate(item.ProcessLevel,item.ratio)"
                        size="65"
                        layer-color="#FEFEFE"
                      >
                        <template slot="default">
                          <div
                            :style="{'margin':'15%','height':'70%','width':'70%','background':backColor(item.ProcessLevel,item.ratio),'border-radius':'45px'}"
                          >
                            <div :style="{'padding':'28%'}">
                              <span
                                :style="{'color':'#ffffff','font-size':'17px'}"
                              >{{textAbbreviate(item.ProcessLevel,item.ratio)}}</span>
                            </div>
                          </div>
                        </template>
                      </van-circle>
                    </template>
                    <template slot="title">
                      <div class="ml-2">
                        <div :style="{'font-size':'16px'}">{{item.ProcessName}}</div>
                      </div>
                    </template>
                    <template slot="label">
                      <div class="ml-2 color-dark">
                        {{(new Date(item.BeginTime).getMonth() + 1) + '月' + new Date(item.BeginTime).getDate() + '日' + new Date(item.BeginTime).getHours() + ':' + (new Date(item.BeginTime).getMinutes()?new Date(item.BeginTime).getMinutes():'00')}}
                        {{'-'}}
                        {{(new Date(item.EndTime).getMonth() + 1) + '月' +new Date(item.EndTime).getDate() + '日' +new Date(item.EndTime).getHours() + ':' + (new Date(item.BeginTime).getMinutes()?new Date(item.BeginTime).getMinutes():'00')}}
                        {{'间上报'}}
                      </div>
                      <div class="mt-1 ml-2 color-gray">
                        <small>
                          未上报
                          <b>{{item.NotReportNum}}</b>
                        </small>
                        <small>
                          完成
                          <b>{{item.FinishedNum}}</b>
                        </small>
                        <small>
                          未完成
                          <b>{{item.UnFinishedNum}}</b>
                        </small>
                        <small>
                          异常
                          <b>{{item.AbnormalNum}}</b>
                        </small>
                      </div>
                    </template>
                    <template slot="right-icon">
                      <i class="mt-4 fa fa-2x fa-angle-right" @click="processItemBtn(item)"></i>
                    </template>
                  </van-cell>
                </template>
              </template>
            </div>
          </template>
          <template v-else>
            <!-- 十二宫格视图模式显示工作任务 -->
            <div class="van-doc-demo-block" v-for="(item,index) in workProcess" :key="index">
              <div class="van-doc-demo-block-title">
                <span class="color-black">{{index}}</span>
                <span class="color-gray ml-1 mr-1">|</span>
                <b class="color-black">{{item.length}}</b>个任务
              </div>
              <van-grid text="title" :border="false" :column-num="4">
                <template v-for="(e,i) in item">
                  <van-grid-item :key="i" @click="processItemBtn(e)">
                    <template slot="icon">
                      <div class="p-0">
                        <van-circle
                          v-model="e.ratio"
                          :rate="e.ratio"
                          size="55"
                          :color="gradientColor(e.ProcessLevel,e.ratio)"
                          :stroke-width="30"
                          :speed="100"
                          :text="textAbbreviate(e.ProcessLevel,e.ratio)"
                          layer-color="#FEFEFE"
                        >
                          <template slot="default">
                            <div
                              :style="{'margin':'15%','height':'70%','width':'70%','background':backColor(e.ProcessLevel,e.ratio),'border-radius':'45px'}"
                            >
                              <div :style="{'padding':'20%'}">
                                <span
                                  :style="{'color':'#ffffff'}"
                                >{{textAbbreviate(e.ProcessLevel,e.ratio)}}</span>
                              </div>
                            </div>
                          </template>
                        </van-circle>
                      </div>
                    </template>
                    <template slot="text">
                      <small style="height:34px;text-align:center;">
                        <!-- <label
                      style="margin-right:0px;padding:1px;background:#777;color:#eee;"
                        >{{textAbbreviate(e.ProcessLevelText)}}</label>-->
                        {{e.ProcessName}}
                        <!-- {{e.ratio + '%'}} -->
                      </small>
                    </template>
                  </van-grid-item>
                </template>
              </van-grid>
            </div>
          </template>
          <div class="text-right color-gray mt-4 pt-4 mr-3">
            <small>
              <i class="fa fa-fw fa-refresh"></i>
              {{ new Date().getHours() + ':' + new Date().getMinutes() }}
            </small>
          </div>
        </div>
      </van-pull-refresh>
    </div>
    <!-- 空数据集提示 -->
    <div class="p-4" v-else>
      <div class="card">
        <div class="intro">
          <!-- <img id="logo" src="../assets/logo.png" /> -->
          <i class="fa fa-tags fa-3x color-gray"></i>
          <!-- <h2>标题</h2> -->
          <p>当前岗位没有可查看的工作情况</p>
        </div>
      </div>
    </div>

    <span
      class="fa-stack"
      v-if="sheet1"
      @click="sheet1=false"
      :style="{'position':'fixed','top':'8px','right':'8px','color':'#FFF','z-index':'9999','text-shadow':'#0084ff 0px 0px 7px'}"
    >
      <i class="fa fa-times fa-stack-1.5x"></i>
      <i class="fa fa-circle-thin fa-stack-2x text-danger"></i>
    </span>
    <!-- 通用环节工作任务详情查看 -->
    <van-popup id="sheet1" v-model="sheet1" class="popup-l0">
      <van-nav-bar class="bg-sys">
        <template slot="title">
          <span class="color-white">{{sheet1Content.item.ProcessName}}</span>
        </template>
      </van-nav-bar>
      <!-- 工作任务详情页头部内容 -->
      <div class="text-left">
        <van-cell-group>
          <van-cell>
            <template slot="title">
              {{sheet1Content.item.ProcessTypeName}} > {{sheet1Content.item.ProcessLevelText}} > 上报完成:
              <b>{{sheet1Content.item.FinishedNum+' / '+sheet1Content.item.TotalNum}}</b>
            </template>
          </van-cell>
          <van-cell>
            <template slot="title">{{sheet1Content.item.Memo}}</template>
          </van-cell>
        </van-cell-group>
        <!-- 判断当前工作任务为考区或考点的情况下显示 -->
        <div v-if="sheet1Content.item.ProcessLevel==2 || sheet1Content.item.ProcessLevel==3">
          <!-- 工作任务完成数量小于应上报人数 -->
          <div v-if="sheet1Content.item.FinishedNum < sheet1Content.item.TotalNum">
            <!-- 消息提醒按钮 -->
            <!-- <van-button
              type="warning"
              size="small"
              class="mb-4 w-100"
              @click="pushBtn"
            >还有{{sheet1Content.item.TotalNum - sheet1Content.item.FinishedNum}}个{{sheet1Content.item.ProcessLevelText}}未上报,提醒上报工作任务</van-button> -->
            <van-button type="warning" size="small" class="mb-4 w-100">还有{{sheet1Content.item.TotalNum - sheet1Content.item.FinishedNum}}个{{sheet1Content.item.ProcessLevelText}}未上报</van-button>
          </div>
          <div v-else>
            <van-button type="primary" size="small" class="mb-4 w-100">工作任务已完成</van-button>
          </div>
        </div>
      </div>
      <template v-if="sheet1Content.data.length > 1">
        <!-- 排序功能操作按钮 -->
        <van-cell title="单元格">
          <template slot="title">
            <van-row>
              <van-col span="8" @click="orderItemBtn(false,false)">默认排序</van-col>
              <van-col span="8" @click="orderItemBtn('ReportStatus',0)">完成状态</van-col>
              <van-col span="8" @click="orderItemBtn('ReportStatus',1)">状态倒序</van-col>
            </van-row>
          </template>
        </van-cell>
      </template>
      <!-- 工作任务进度详情列表 -->
      <div v-if="sheet1Content.data" class="demo-skeleton">
        <div v-for="(item,index) in sheet1Content.data" :key="index" class="demo-preview">
          <van-icon
            :name="(item.ProcessStatus==1)?'certificate':'underway-o'"
            :color="(item.ProcessStatus==1)?'#0788ff':'#11d6a1'"
            class="pt-2 pl-2"
          />
          <div class="demo-content">
            <span class="text">{{item.RangeName}}</span>
            <p>
              <small>{{item.OperationTime || item.ProcessStatusText}}</small>
            </p>
            <!-- 加载工作环节插件内容 -->
            <component
              v-if="item.PlugJson"
              v-bind:is="item.PlugJson.PlugID"
              class="pt-2 pb-2"
              style="border:0 dashed #fccc"
              :PlugJson="item.PlugJson"
            ></component>
            <!-- 文件列表{{item.PlugJson.FileList}} -->
            <div v-if="item.PlugJson.FileList">
              <van-image
                v-for="(e,i) in item.PlugJson.FileList"
                :key="i"
                width="45"
                height="45"
                fit="cover"
                class="m-1"
                :src="e.ThumbnailImages"
                :alt="e.FileName"
                @click="fileItemBtn(e)"
              />
            </div>
            <!-- 子任务列表 -->
            <div class="sub">
              <!-- 子任务完成情况 -->
              <small class="color-yellow" v-if="item.PeerWorkProcessList.length > 0">子任务完成情况</small>
              <!-- <template>{{item.PeerWorkProcessList}}</template> -->
              <van-steps direction="vertical" :active="-1" inactive-icon="arrow-down">
                <van-step v-for="(sub,si) in item.PeerWorkProcessList" :key="si">
                  <small
                    :class="(sub.ProcessStatus==1)?'color-black':''"
                  >{{sub.ProcessName}} [{{sub.ProcessStatusName}}]</small>
                  <!-- <p> <small>{{sub.ProcessStatusName}}</small> </p> -->
                </van-step>
              </van-steps>
              <!-- 下级机构子任务完成进度 -->
              <small class="color-yellow" v-if="item.SubWorkProcessList.length > 0">下级机构子任务完成进度</small>
              <!-- <template>{{sheet1Content.item.SubWorkProcessList}}</template> -->
              <van-steps direction="vertical" :active="-1">
                <van-step v-for="(sub,si) in item.SubWorkProcessList" :key="si">
                  <small
                    :class="(sub.AllNum==sub.FinishedNum)?'color-black':''"
                  >{{sub.ProcessName}} [{{sub.FinishedNum + ' / ' + sub.AllNum}}]</small>
                  <!-- <p> <small>{{sub.ProcessStatusName}}</small> </p> -->
                </van-step>
              </van-steps>
            </div>
          </div>
        </div>
      </div>
      <div v-else>获取详细信息错误</div>
    </van-popup>
    <van-popup v-model="sheet2" position="bottom" round closeable class="popup-l2">
      <van-nav-bar title="文件查看" left-text="附件" />
      <div class="mt-4 p-4">
        <van-image width="100%" :src="sheet2Content.ThumbnailImages" />
        <div class="mt-2 mb-2 w-100 text-overflow">{{sheet2Content.FileName}}</div>
        <!-- <a :href="sheet2Content.FileUrl" target="_blank">下载</a> -->
        <span class="color-yellow" @click="downloadFile(sheet2Content.FileUrl)">下载</span>
      </div>
    </van-popup>
    <div class="listModeDiv" v-show="false">
      <!-- <van-switch v-model="listMode" size="14px" /> -->
      <i
        class="fa fa-lg color-white"
        :class="(listMode)?'fa-list':'fa-th'"
        @click="listMode=(!listMode)"
      ></i>
    </div>
    <!-- 加载数据时显示遮罩层 -->
    <van-overlay :show="overlayshow">
      <div class="wrapper">
        <van-loading vertical>工作情况数据加载中...</van-loading>
      </div>
    </van-overlay>
  </div>
</template>

<script>
var requireComponents = {};
const chartsComponents = require.context(
  "@/exam-plugin/process/charts/",
  true,
  /\.vue/
);
chartsComponents.keys().forEach(element => {
  // 组件实例
  const reqCom = chartsComponents(element);
  // 截取路径作为组件名
  const reqComName = element.split("/")[1];
  // 截取组件去扩展名后, 添加到组件对象
  requireComponents[reqComName.split(".")[0]] = reqCom.default || reqCom;
});
export default {
  name: "WorkSituation",
  data() {
    return {
      ratio: 0, //时间线进度控制变量
      isLoading: false, //刷新读取状态
      workProcess: [], //工作任务
      listMode: false, //列表模式
      sheet1: false,
      sheet1Param: {}, //窗口1参数,排序功能中使用
      sheet1Content: {
        item: {},
        data: []
      },
      sheet2: false,
      sheet2Content: {},
      overlayshow: true // 遮罩层
    };
  },
  watch: {
    listMode: function() {
      this.workProcess = [];
      this.drawWorkProcessScanList();
    }
  },
  components: requireComponents,
  methods: {
    onRefresh() {
      setTimeout(() => {
        this.isLoading = false;
      }, 500);
    },
    gradientColor(text, ratio) {
      if (ratio == 0) {
        return {
          //环形进度条渐变色
          "0%": "#ffffff",
          "100%": "#ffffff"
        };
      }
      switch (text) {
        case 1:
          return {
            //环形进度条渐变色
            "0%": "#42e1ff",
            "100%": "#21b8ff"
          };
        case 2:
          return {
            //环形进度条渐变色
            "0%": "#ffc0a4",
            "100%": "#fe5a27"
          };
        case 3:
          return {
            //环形进度条渐变色
            "0%": "#40f4c4",
            "100%": "#16e2ad"
          };
        default:
          return {
            //环形进度条渐变色
            "0%": "#3fecff",
            "100%": "#6149f6"
          };
      }
    },
    backColor(text, ratio) {
      if (ratio == 0) {
        return "linear-gradient(45deg,  #979797 0%,#D7D7D7 100%)";
      }
      switch (text) {
        case 1:
          return "linear-gradient(45deg,  #42e1ff 0%,#21b8ff 100%)";
        case 2:
          return "linear-gradient(45deg,  #ffc0a4 0%,#fe5a27 100%)";
        case 3:
          return "linear-gradient(45deg,  #40f4c4 0%,#16e2ad 100%)";
        default:
          return "linear-gradient(45deg,  #3fecff 0%,#6149f6 100%)";
      }
    },
    textAbbreviate(text, ratio) {
      if (ratio == 100) {
        return "√";
      }
      switch (text) {
        case 1:
          return "省";
        case 2:
          return "市";
        case 3:
          return "校";
        default:
          return text;
      }
    },
    drawWorkProcessScanList() {
      this.overlayshow = true; // 显示遮罩层
      this.apiWorkProcessScanGet(
        {
          WorkID: this.getWork().WorkID,
          OrganID: this.getAddr().OrganID,
          RoleID: this.getAddr().RoleID,
          RangeID: this.getAddr().RangeID
        },
        this,
        res => {
          if (res.code == 20000) {
            this.overlayshow = false; //获取工作任务后隐藏加载提示遮罩层
            //过滤掉子任务将主任务添加到workArray数组进行后面的条件判断
            var workArray = [];
            res.data.forEach(e => {
              if (e.ParentProcessID == "") {
                workArray.push(e);
              }
            });
            //循环计算完成情况百分比
            workArray.forEach((e, index) => {
              e.ratio = parseInt((e.FinishedNum / e.TotalNum) * 1000) / 10;
              if (e.FinishedNum > 0) this.ratio = index;
            });
            //判断当前页显示方式(分类渲染,时间线列表渲染)
            if (this.listMode) {
              this.workProcess = workArray; //将api返回的工作任务数组付给前端变量名
            } else {
              this.workProcess = {}; //将工作任务数组类型改为json对象
              workArray.forEach(item => {
                //判断工作任务类别对象键名是否存在
                if (this.workProcess[item.ProcessTypeName]) {
                  // 键名已经存在,跳过
                } else {
                  // 键名不存在,添加键名指定空数组
                  this.workProcess[item.ProcessTypeName] = [];
                }
                this.workProcess[item.ProcessTypeName].push(item);
              });
            }
          }
        }
      );
    },
    processItemBtn(item) {
      this.sheet1Content.data = [];
      this.sheet1 = true;
      this.sheet1Param = {
        WorkID: this.getWork().WorkID,
        OrganID: this.getAddr().OrganID,
        RoleID: this.getAddr().RoleID,
        RangeID: this.getAddr().RangeID,
        ProcessID: item.ProcessID,
        IsThumbnail: true
      };
      this.sheet1Content.item = item;
      this.apiWorkProcessScanGet(this.sheet1Param, this, res => {
        if (res.code == 20000) {
          this.sheet1Content.data = res.data;
        }
      });
    },
    orderItemBtn(Order, Sortord) {
      let setOrderParam = this.sheet1Param;
      setOrderParam.Order = Order ? Order : null;
      setOrderParam.Sortord = Sortord ? Sortord : null;
      this.apiWorkProcessScanGet(setOrderParam, this, res => {
        if (res.code == 20000) {
          this.sheet1Content.data = res.data;
        }
      });
      //eslint-disable-next-line
      console.log(setOrderParam, "排序操作");
      setOrderParam = {};
    },
    fileItemBtn(fileitem) {
      //eslint-disable-next-line
      console.log(fileitem);
      this.sheet2 = true;
      this.sheet2Content = fileitem;
    },
    pushBtn() {
      //消息推送-提醒上报工作任务
      this.$dialog
        .confirm({
          title: "提示",
          message: "确定发送工作上报提醒?"
        })
        .then(() => {
          // on confirm
          //eslint-disable-next-line
          console.log("消息提醒", this.sheet1Content);
          this.apiPushPost(
            {
              WorkID: this.getWork().WorkID,
              OrganID: this.getAddr().OrganID,
              RoleID: this.getAddr().RoleID,
              RangeID: this.getAddr().RangeID,
              PushType: "subordinate",
              ProcessID: this.sheet1Content.item.ProcessID
            },
            this,
            res => {
              //eslint-disable-next-line
              if (res.code == 20000) {
                this.$toast(res.message);
              } else {
                this.$dialog.alert({ message: res.message });
              }
            }
          );
        })
        .catch(() => {
          // on cancel
        });
    }
  },
  created() {
    this.drawWorkProcessScanList();
  }
};
</script>

<style scoped>
#WorkSituation {
  background: #efefef;
  min-height: 700px;
}
.van-card {
  background: #fff !important;
}
.van-doc-demo-block {
  margin: 0 2% 3% 2%;
  padding: 1% 0 5% 0;
  width: 96%;
  background: #ffffff;
  display: block;
  border-radius: 2%;
}
.van-doc-demo-block-title {
  margin: 0;
  padding: 9px 0 12px 12px;
  color: rgba(69, 90, 100, 0.6);
  font-weight: normal;
  font-size: 14px;
  line-height: 16px;
  text-align: left;
  border-bottom: 1px solid #f1f1f1;
}
.listModeDiv {
  position: fixed;
  width: 2rem;
  height: 2rem;
  right: 3%;
  top: 6%;
  background: rgba(69, 90, 100, 0.6);
  border-radius: 2rem;
  padding: 0.2rem;
}
.listModeDiv i {
  width: 2rem;
  line-height: 2.3rem;
  height: 2rem;
}
/* 工作任务状态提示样式 */
.side-nav {
  margin: 2% 2% 3% 2%;
  padding: 7px 5px 5px 5px;
  width: 94%;
  background: #ffffff;
  border-radius: 5px;
}
.side-nav .vant-title {
  margin: 5px 0 5px 0;
}
.side-nav .vant-title,
.side-nav .vant-desc {
  padding-left: 16px;
  font-weight: normal;
  -webkit-user-select: none;
  user-select: none;
}
.side-nav .vant-desc {
  margin: 0 0 15px;
  color: #7d7e80;
  font-size: 14px;
}
.side-nav .vant-title,
.side-nav .vant-desc {
  padding-left: 16px;
  font-weight: normal;
  -webkit-user-select: none;
  user-select: none;
}
/* 列表样式切换 */
.mobile-switch-lang {
  position: absolute;
  top: 12px;
  right: 10px;
  overflow: hidden;
  color: #1989fa;
  font-size: 12px;
  cursor: pointer;
}
.mobile-switch-lang i.active {
  color: #fff;
  /* background-color: #1989fa; */
  color: #1989fa;
}
.mobile-switch-lang i:first-child {
  border-right: none;
  border-radius: 3px 0 0 3px;
  border-right: 1px solid #ebedf0;
}
.mobile-switch-lang i {
  display: inline-block;
  width: 48px;
  color: #323233;
  line-height: 22px;
  text-align: center;
  background-color: #fff;
  /*  border: 1px solid #ebedf0; */
}
</style>